<template>
	<div class="banners">
		<div class="banners__content">
			<div class="banners__about">
				<p class="banners__about-text">
					{{ $t('pages.publishers.sections.formats.bannersContent.about.text') }}
				</p>
			</div>
			<div class="banners__description">
				<div v-for="(block, i) in blocks" :key="i" class="banners__description-block">
					<Icon name="lets-icons:check-fill" size="40" />
					<BlocksPublishersFormatTabBlockButtons
						v-if="$rt(block.type) === 'buttons'"
						:block="block"
						:selected-format="selectedFormat"
						@select-format="handleSelectFormat" />
					<BlocksPublishersFormatTabBlockChips
						v-else-if="$rt(block.type) === 'chips'"
						:block="block" />
					<BlocksPublishersFormatTabBlockList v-else-if="$rt(block.type) === 'list'" :block="block" />
					<BlocksPublishersFormatTabBlockText v-else-if="$rt(block.type) === 'text'" :block="block" />
				</div>
			</div>
		</div>

		<BlocksPublishersFormatTabBannersExample
			:selected-format="selectedFormat"
			:formats="availableFormats"
			@change-format="handleSelectFormat" />
	</div>
</template>
<script setup lang="ts">
	type BannerBlock = {
		type: string
		title?: string
		items?: { title: string; buttons: string[] }[]
		chips?: string[]
		list?: string[]
		text?: string
	}
	const selectedFormat = ref('320×480')

	const handleSelectFormat = (format: string) => {
		selectedFormat.value = format
	}

	const { tm, rt } = useI18n()

	const blocks = computed<BannerBlock[]>(
		() => tm('pages.publishers.sections.formats.bannersContent.blocks') as BannerBlock[]
	)

	const availableFormats = computed(() =>
		blocks.value
			.filter((item) => rt(item.type) === 'buttons' && item.items)
			.flatMap((item) => item.items!.flatMap((group) => group.buttons.map((button) => rt(button))))
	)
</script>
<style lang="scss" scoped>
	.banners {
		display: flex;
		gap: 48px;
		align-items: flex-start;

		@media (width <= 767.98px) {
			flex-direction: column-reverse;
			gap: 24px;
			align-items: center;
		}
		&__content {
			display: flex;
			flex-direction: column;
			gap: 8px;
			// flex: 0 0 50%;
			// max-width: 50%;
			width: 100%;
		}
		&__about {
			padding: 24px;
			background-color: var(--white);
			border-radius: 20px;
			@media (width <= 575.98px) {
				padding: 16px;
			}
			&-text {
				font-size: 16px;
			}
		}
		&__description {
			display: flex;
			flex-direction: column;
			gap: 24px;
			padding: 24px;
			background-color: var(--white);
			border-radius: 20px;
			&-block {
				display: flex;
				gap: 16px;

				@media (width <= 767.98px) {
					flex-direction: column;
					gap: 8px;
				}
				.iconify {
					flex-shrink: 0;
					margin-top: -4px;
					color: var(--primary);

					@media (width <= 767.98px) {
						margin-top: 0;
						margin-left: -8px;
					}
				}
			}
		}
	}
</style>
